import {fetchNewsItems} from './fetchNewsItems';

export interface ICenteredPage {
    pageNumber: number;
    isActive: boolean;
    isLeftMost: boolean;
    isRightMost: boolean;
    isEllipsis: boolean;
}

export function newsPaging (centeredPages: ICenteredPage[], totalpage: number, currentpage: number, id: string, terms: string, sort: string, searchterm: string) {
    //console.log(centeredPages);
    const newsPagination:HTMLElement = <HTMLElement>document.getElementById('newspagination');
    if (totalpage <= 1 || !newsPagination) return;

    newsPagination.innerHTML = '';
    let prevli:HTMLLIElement=<HTMLLIElement>document.createElement("li");
    prevli.setAttribute('class', "directory-pagination-arrow directory-pagination-arrow-left");
    let prevbtn:HTMLButtonElement=<HTMLButtonElement>document.createElement("button");
    prevbtn.setAttribute('class', "un-button hyperlink h6-style directory-pagination-button-news-prev");
    let prevsvg:HTMLLIElement=<HTMLLIElement>document.createElement("svg");
    prevsvg.setAttribute('class', "svg-icon directory-pagination-arrow-icon");
    prevsvg.setAttribute('aria-hidden', "true");
    prevsvg.setAttribute('focusable', "false");
    let prevuse:HTMLLIElement=<HTMLLIElement>document.createElement("use");
    prevuse.setAttribute('xmlns:xlink', "http://www.w3.org/1999/xlink");
    prevuse.setAttribute('xlink:href', "#icon-left-arrow");
    prevsvg.appendChild(prevuse);
    prevbtn.appendChild(prevsvg);
    let prevspan:HTMLLIElement=<HTMLLIElement>document.createElement("span");
    prevspan.setAttribute('class', "directory-pagination-arrow-text");
    prevspan.textContent = 'Previous';
    if (currentpage > 1)
    {
        prevbtn.addEventListener('click', (e:Event) => fetchNewsItems(id, terms, sort, currentpage-1, searchterm));
    }
    else
    {
        prevbtn.disabled = true;
    }
    prevbtn.appendChild(prevspan);
    prevli.appendChild(prevbtn);
    newsPagination.appendChild(prevli);
   
    centeredPages.forEach(element => {
        const isDisabled = element.isActive || element.isEllipsis;
        
        const isEllipsis = element.isEllipsis ? "ellipsis" : "";
        const isActive = element.isActive ? "active" : "";
        const displayPage = element.isActive ? "Current Page" : "page";
        const displayNumber = element.isEllipsis ? "..."
            : element.isLeftMost ? "1"
                : element.isRightMost ? totalpage.toString()
                    : element.pageNumber.toString();
       
        let li:HTMLLIElement=<HTMLLIElement>document.createElement("li");
        li.setAttribute('class', `directory-pagination-list-item ${isEllipsis} ${isActive}`);
        li.setAttribute('data-id', "pageLinks");
        let pagehiddenspan:HTMLLIElement=<HTMLLIElement>document.createElement("span");
        pagehiddenspan.setAttribute('class', "visually-hidden");
        pagehiddenspan.textContent = displayPage;
        let pagenumberspan:HTMLLIElement=<HTMLLIElement>document.createElement("span");
        pagenumberspan.textContent = displayNumber;

        if (isDisabled)
        {
            let span:HTMLLIElement=<HTMLLIElement>document.createElement("span");
            span.setAttribute('class', "directory-pagination-text bold");
            span.appendChild(pagehiddenspan);
            span.appendChild(pagenumberspan);
            li.appendChild(span);
        }
        else
        {
            let btn:HTMLButtonElement=<HTMLButtonElement>document.createElement("button");
            btn.setAttribute('class', "un-button hyperlink directory-pagination-button");
            btn.setAttribute('id', `newspage-${element.pageNumber}`);
            btn.addEventListener('click', (e:Event) => fetchNewsItems(id, terms, sort, element.pageNumber, searchterm));
            btn.appendChild(pagehiddenspan);
            btn.appendChild(pagenumberspan);
            li.appendChild(btn);
        }
        newsPagination.appendChild(li);
    });

    let nextli:HTMLLIElement=<HTMLLIElement>document.createElement("li");
    nextli.setAttribute('class', "directory-pagination-arrow directory-pagination-arrow-right");
    let nextbtn:HTMLButtonElement=<HTMLButtonElement>document.createElement("button");
    nextbtn.setAttribute('class', "un-button hyperlink h6-style directory-pagination-button-news-next");
    let nextsvg:HTMLLIElement=<HTMLLIElement>document.createElement("svg");
    nextsvg.setAttribute('class', "svg-icon directory-pagination-arrow-icon");
    nextsvg.setAttribute('aria-hidden', "true");
    nextsvg.setAttribute('focusable', "false");
    let nextuse:HTMLLIElement=<HTMLLIElement>document.createElement("use");
    nextuse.setAttribute('xmlns:xlink', "http://www.w3.org/1999/xlink");
    nextuse.setAttribute('xlink:href', "#icon-right-arrow");
    nextsvg.appendChild(nextuse);
    nextbtn.appendChild(nextsvg);
    let nextspan:HTMLLIElement=<HTMLLIElement>document.createElement("span");
    nextspan.setAttribute('class', "directory-pagination-arrow-text");
    nextspan.textContent = 'Next';
    if (currentpage < totalpage)
    {
        nextbtn.addEventListener('click', (e:Event) => fetchNewsItems(id, terms, sort, currentpage+1, searchterm));
    }
    else
    {
        nextbtn.disabled = true;
    }
    nextbtn.appendChild(nextspan);
    nextli.appendChild(nextbtn);
    newsPagination.appendChild(nextli);
}